import CompanyNotes from "components/company/v3/CompanyNotes";
import { CompanyMenuSlugEnum } from "components/company/v3/menu/enums";
import type { MenuOption } from "components/company/v3/menu/types";
import type { Selfie } from "lib/hooks/useSelfie";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import {
  BarChart3Icon,
  CalendarDaysIcon,
  ChartSplineIcon,
  CircleDollarSignIcon,
  InfoIcon,
  LineChartIcon,
  MessageCircleIcon,
  PanelsTopLeftIcon,
  PieChartIcon,
  SearchCheckIcon,
  SettingsIcon,
  UserCogIcon,
  UserPenIcon,
} from "lucide-react";
import type { IntlShape } from "react-intl";
import { format } from "util";

export default function getAmericanMenus(selfie: Selfie, tickerSymbol: string, intl: IntlShape) {
  const basePath = format("/us/%s", tickerSymbol.toLowerCase());
  const valuationPath = format("/us/%s/valuation", tickerSymbol.toLowerCase());

  return [
    {
      slug: CompanyMenuSlugEnum.ABOUT,
      label: intl.formatMessage({
        defaultMessage: "Sobre",
        description: "Item do menu de navegação das empresas",
        id: "p9OPjp",
      }),
      icon: <InfoIcon className="size-5 lg:size-6" />,
      href: format("%s/about", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.CARDS,
      label: intl.formatMessage({
        defaultMessage: "Cards",
        description: "Item do menu de navegação das empresas",
        id: "5wpQkZ",
      }),
      icon: null,
      href: null,
    },
    selfie?.isPremium && {
      slug: CompanyMenuSlugEnum.GOVERNANCE,
      label: intl.formatMessage({
        defaultMessage: "Governança",
        description: "Item do menu de navegação das empresas",
        id: "5LzpEC",
      }),
      icon: <UserCogIcon className="size-5 lg:size-6" />,
      href: format("%s/governance", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.EVENTS,
      label: intl.formatMessage({
        defaultMessage: "Eventos",
        description: "Item do menu de navegação das empresas",
        id: "hVbTfJ",
      }),
      icon: <CalendarDaysIcon className="size-5 lg:size-6" />,
      href: format("%s/events", basePath),
    },
    selfie?.isPremium && {
      slug: CompanyMenuSlugEnum.OPERATING_SEGMENTS,
      label: intl.formatMessage({
        defaultMessage: "Receitas",
        description: "Item do menu de navegação das empresas",
        id: "+ooVOr",
      }),
      icon: <PieChartIcon className="size-5 lg:size-6" />,
      href: format("%s/operating-segments", basePath),
    },
    selfie?.isPremium && {
      slug: CompanyMenuSlugEnum.LIQUIDITY,
      label: intl.formatMessage({
        defaultMessage: "Liquidez",
        description: "Item do menu de navegação das empresas",
        id: "WGjgSd",
      }),
      icon: <BarChart3Icon className="size-5 lg:size-6" />,
      href: format("%s/liquidity", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.QUOTES,
      label: intl.formatMessage({
        defaultMessage: "Cotação",
        description: "Item do menu de navegação das empresas",
        id: "3gozhL",
      }),
      icon: <LineChartIcon className="size-5 lg:size-6" />,
      href: format("%s/quotes", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.FINANCIALS,
      label: intl.formatMessage({
        defaultMessage: "Balanços",
        description: "Item do menu de navegação das empresas",
        id: "bSuut8",
      }),
      icon: <PanelsTopLeftIcon className="size-5 lg:size-6" />,
      href: format("%s/financials", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.KPIS,
      label: intl.formatMessage({
        defaultMessage: "KPIs",
        description: "Item do menu de navegação das empresas",
        id: "2NgXv+",
      }),
      icon: <ChartSplineIcon className="size-5 lg:size-6" />,
      href: format("%s/kpis", basePath),
    },
    {
      slug: CompanyMenuSlugEnum.VALUATION,
      label: intl.formatMessage({
        defaultMessage: "Valuation",
        description: "Item do menu de navegação das empresas",
        id: "HTSDcj",
      }),
      icon: <CircleDollarSignIcon className="size-5 lg:size-6" />,
      href: valuationPath,
    },
    selfie?.isPremium && {
      slug: CompanyMenuSlugEnum.HIGHLIGHTS,
      label: intl.formatMessage({
        defaultMessage: "Análises",
        description: "Item do menu de navegação das empresas",
        id: "+QmBkz",
      }),
      icon: <SearchCheckIcon className="size-5 lg:size-6" />,
      href: format("%s/highlights", basePath),
    },
    selfie?.isPremium
      ? {
          slug: CompanyMenuSlugEnum.DISCUSSIONS,
          label: intl.formatMessage({
            defaultMessage: "Discussões",
            description: "Item do menu de navegação das empresas",
            id: "6+15gi",
          }),
          icon: <MessageCircleIcon className="size-5 lg:size-6" />,
          href: format("%s/discussions", basePath),
        }
      : null,
    selfie?.isPremium && {
      slug: CompanyMenuSlugEnum.NOTES,
      label: intl.formatMessage({
        defaultMessage: "Anotações",
        description: "Item do menu de navegação das empresas",
        id: "JH1ccU",
      }),
      icon: <UserPenIcon className="size-5 lg:size-6" />,
      href: null,
      render: CompanyNotes,
    },
    selfie && {
      slug: CompanyMenuSlugEnum.SETTINGS,
      label: intl.formatMessage({
        defaultMessage: "Configurações",
        description: "Item do menu de navegação das empresas",
        id: "WUnTuy",
      }),
      icon: <SettingsIcon className="size-5 lg:size-6" />,
      href: format("%s/settings", basePath),
    },
  ].filter(notUndefinedOrNull) as MenuOption[];
}
